<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>营销</el-breadcrumb-item>
            <el-breadcrumb-item>秒杀活动</el-breadcrumb-item>
            <el-breadcrumb-item>活动商品</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="dis-flex">
            <div class="second-swaper">
                <second></second>
            </div>
            <div class="flex-box">
                <div class="btns">
                    <el-button type="primary" size="small" @click="add" v-auth="['stpre/app.seckill/add']">添加商品</el-button>
                </div>
                <Table
                        :columns="columns"
                        :data="lists"
                        ref="selection"
                        highlight-row
                        no-userFrom-text="暂无数据"
                        no-filtered-userFrom-text="暂无筛选结果">
                    <template slot-scope="{ row, index }" slot="is_fail">
                        <Icon
                                type="md-checkmark"
                                v-if="row.is_fail === 1"
                                color="#0092DC"
                                size="14"
                        />
                        <Icon type="md-close" v-else color="#ed5565" size="14" />
                    </template>
                    <template slot-scope="{ row, index }" slot="image">
                        <div class="acea-row">
                            <viewer>
                                <div class="tabBox_img">
                                    <img v-lazy="row.goods.product_pic_main" />
                                </div>
                            </viewer>
                        </div>

                    </template>
                    <template slot-scope="{ row, index }" slot="goods_name">
                        <div>{{row.goods.name}}</div>
                    </template>

                    <template slot-scope="{ row, index }" slot="seckill_min_price">
                        <span>{{ row.seckill_min_price }}~{{ row.seckill_max_price }}</span>
                    </template>
                    <template slot-scope="{ row, index }" slot="status_item">
                        {{ row | filterStatus }}
                    </template>
                    <template slot-scope="{ row, index }" slot="start_time">
                        <span> {{ row.start_time | formatDate }}</span>
                    </template>
                    <template slot-scope="{ row, index }" slot="end_time">
                        <span> {{ row.end_time | formatDate }}</span>
                    </template>
                    <template slot-scope="{ row, index }" slot="status">
                        <Tag color="blue" v-if="row.status">上架</Tag>
                        <Tag v-else>下架</Tag>
                    </template>
                    <template slot-scope="{ row, index }" slot="action">
                        <a @click="edit(row)">编辑</a>
                        <Divider type="vertical" />
                        <a @click="del(row, '删除秒杀商品', index)">删除</a>
                    </template>
                </Table>
                <el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page"
                               :current-page.sync="pageNum" :page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize"
                               layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
    import second from "./second.vue";
    import { formatDate } from "@/utils/validate";

    export default {
        name: 'index',
        components: { second },
        filters: {
            formatDate(time) {
                if (time !== 0) {
                    let date = new Date(time * 1000);
                    return formatDate(date, "yyyy-MM-dd hh:mm");
                }
            },
            filterStatus(val) {
                let nowTime = Date.parse(new Date()) / 1000;
                if (
                    val.start_time < nowTime &&
                    val.stop_time > nowTime &&
                    val.status == 1
                ) {
                    return "活动进行中";
                } else if (val.stop_time < nowTime && val.status == 1) {
                    return "活动已结束";
                } else {
                    return "活动未开始";
                }
            },
        },
        data() {
            return {
                columns: [
                    {
                        title: "ID",
                        key: "active_id",
                        width: 80,
                    },
                    {
                        title: "商品图",
                        slot: "image",
                        minWidth: 80,
                    },
                    {
                        title: "商品名称",
                        slot: "goods_name",
                        minWidth: 200,
                    },
                    {
                        title: "活动销量(件)",
                        key: "actual_sales",
                        minWidth: 100,
                    },
                    {
                        title: "开始时间",
                        slot: "start_time",
                        minWidth: 150,
                    },
                    {
                        title: "结束时间",
                        slot: "end_time",
                        minWidth: 150,
                    },
                    {
                        title: "上架状态",
                        slot: "status",
                        minWidth: 100,
                    },
                    {
                        title: "操作",
                        slot: "action",
                        fixed: "right",
                        minWidth: 130,
                    },
                ],
                lists: [],
                isLoad: false,
                // 每页多少条数据
                pageNum: 0,
                pageSize: 20,
                total: 0,
                // 当前在第几页
                page: 1,
            }
        },
        created() {
            this.loadList()
        },
        methods: {
            sizeReload(val) {
                this.item.pageSize = val
                this.loadList()
            },
            pageReload(val) {
                this.item.page = val
                this.loadList()
            },
            loadList() {
                if (this.isLoad)
                    return
                this.isLoad = !this.isLoad
                this.axios.post('/store/app.seckill.active/list', {
                    page: this.page,
                    pagesize: this.pageSize
                })
                .then(res => {
                    this.isLoad = !this.isLoad
                    // 获取数据
                    this.lists = res.data.list.data
                    this.total = res.data.list.total
                })
                .catch(() => {
                    this.isLoad = !this.isLoad
                })
            },
            // 跳转到edit添加
            add() {
                this.$router.push({path: '/app/seckill/add.html'});
            },
            // 传一个ID跳转到edit页面，进行编辑
            edit(row) {
                this.$router.push({
                    path: '/app/seckill/add.html',
                    query: {
                        id: row.active_id
                    }
                });
            },
            del (row) {
                this.$Modal.confirm({
                    title: '删除',
                    content: '<p>确定要删除数据吗？</p><p>删除后将无法恢复，请谨慎操作！</p>',
                    loading: true,
                    onOk: () => {
                        this.axios.post('/store/app.seckill.active/delete', {
                            active_id: row.active_id
                        })
                        .then(async (res) => {
                            if (res.code == 1) {
                                this.$Modal.remove();
                                this.loadList()
                            } else {
                                this.$Message.error(res.msg);
                                this.$Modal.remove();
                            }
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                    }
                })
            },
        }
    }
</script>
<style scoped lang="less">
</style>
